import React from 'react';
import { HtmlParser } from 'components/common';
import PropTypes from 'prop-types';

const AgreementText = ({ agreementText, links }) => {
  const statement = links ? links.reduce((mem, link) => {
    const myLink = `<a key=${link.id} class=agreement href=${link.href}>${link.label}</a>`;
    return mem.replace(`$\{${link.id}}`, myLink);
  }, agreementText) : agreementText;

  return <HtmlParser htmlString={statement} />;
};

AgreementText.propTypes = {
  agreementText: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
};

export default AgreementText;
